import { UserMemberStatusDto } from '@act/shared/data-transfer-objects';
import { TaggableChip } from './TaggableChip';
import { getStatusColor, isStatusSaturated } from './getStatusColors.util';

export interface MemberStatusTagProps {
  status: UserMemberStatusDto;
}

export const MemberStatusTag = ({ status }: MemberStatusTagProps) => {
  const variant = ['new', 'queued'].includes(status?.key)
    ? 'outlined'
    : 'filled';

  return (
    <TaggableChip
      label={status?.name || 'Missing status'}
      color={getStatusColor(status)}
      variant={variant}
      isTag
      isSaturated={isStatusSaturated(status)}
    />
  );
};
